import instObj from '@/backend/axios-instances'

const resource = "/warehouses/location"
const instance = instObj.baseInstance

export default {
  get(locationId, parameters) {
    return instance.get(`${resource}/${locationId}`, { params: parameters });
  },
  put(locationId, data, parameters) {
    return instance.put(`${resource}/${locationId}`, data, { params: parameters });
  },
  delete(locationId) {
    return instance.delete(`${resource}/${locationId}`);
  }
}
